module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Thin.e1ab8e624b4150e82c28c25fa2099c5c.woff";